import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import carresHoriz from '../../images/carres_horiz.png';
import './Header.css';
import { Tuile } from './Tuile';

export class PanelApplications extends Component {

    static defaultProps = {
        droits: {},
        isOpen: false,
        onDismiss: () => null,
        urlEBook: "",
        urlPrimPromo: "",
        urlSectionMandat: "",
    };

    _onRenderFooterContent = () => {
        return <img src={carresHoriz} alt="Carrés" />;
    };

    render = () => {

        const { droits, isOpen, onDismiss, urlEBook, urlPrimPromo, urlSectionMandat } = this.props;
        const { afficherTuileAdministrationsDesVentesV4, afficherTuileAlarme, afficherTuileBackOfficeCapsuleClient, afficherTuileBackOfficeDemande, afficherTuileConfiguration, afficherTuileControleDeGestion, afficherTuileDocument, afficherTuileEBook, afficherTuileMandat, afficherTuileNews, afficherTuileOperation, afficherTuilePrimPromo, afficherTuileProspection, afficherTuileReporting, afficherTuileSignatureEiffage, afficherTuileTableauDeBord, afficherTuileVente } = droits;

        let tuiles = [];

        if (afficherTuileProspection)
            tuiles.push(<Tuile iconName="Group" key="prospection" onClick={onDismiss} text="CRM Prospection" tileSize="tile-wide" to="/Prospection/ListeContacts" />);

        if (afficherTuileVente)
            tuiles.push(<Tuile iconName="Commitments" key="ventes" onClick={onDismiss} text="CRM Espace de vente" tileSize="tile-wide" to="/Vente/EspaceDeVente/V/1" />);

        if (afficherTuileReporting)
            tuiles.push(<Tuile iconName="ReportLibrary" key="reportings" onClick={onDismiss} text="Reportings" to="/Reporting/ListeRapports" />);

        if (afficherTuileOperation)
            tuiles.push(<Tuile iconName="CityNext" key="operations" onClick={onDismiss} text="Opérations" to="/Operations/ListeOperations" />);

        if (afficherTuileMandat)
            tuiles.push(<Tuile iconName="TextDocumentShared" key="mandats" onClick={onDismiss} text="Mandats" to={urlSectionMandat} />);

        if (afficherTuileDocument)
            tuiles.push(<Tuile iconName="TextDocument" key="documents" onClick={onDismiss} text="Documents" to="/Documents/GestionDocuments" />);

        if (afficherTuileAdministrationsDesVentesV4)
            tuiles.push(<Tuile iconName="FinancialSolid" key="adv" onClick={onDismiss} text="ADV" to="/ADV/AppelsDeFonds" />);

        if (afficherTuileEBook)
            tuiles.push(<Tuile href={urlEBook} iconName="DocumentSet" key="ebook" onClick={onDismiss} text="EBook" />);

        if (afficherTuilePrimPromo)
            tuiles.push(<Tuile href={urlPrimPromo} iconName="DocumentSet" key="primpromo" onClick={onDismiss} text="PrimPromo" />);

        if (afficherTuileTableauDeBord)
            tuiles.push(<Tuile iconName="BIDashboard" key="dashboard" onClick={onDismiss} text="Tableau de bord" to="/TableauDeBord" />);

        if (afficherTuileNews)
            tuiles.push(<Tuile iconName="News" key="news" onClick={onDismiss} text="News" to="/News/ListeNews" />);

        if (afficherTuileControleDeGestion)
            tuiles.push(<Tuile iconName="Money" key="cg" onClick={onDismiss} text="Contrôle de gestion" to="/ControleDeGestion/Recapitulatif" />);

        if (afficherTuileConfiguration)
            tuiles.push(<Tuile iconName="Settings" key="configuration" onClick={onDismiss} text="Configuration" to="/Configuration" />);

        if (afficherTuileBackOfficeCapsuleClient)
            tuiles.push(<Tuile iconName="ChatInviteFriend" key="espacesClients" onClick={onDismiss} text="Espace Client" to="/BackOfficeCapsuleClient/CapsuleClient" />);

        if (afficherTuileBackOfficeDemande)
            tuiles.push(<Tuile iconName="Send" key="backOffice" onClick={onDismiss} text="Back Office" to="/BackOffice/Demandes" />);

        if (afficherTuileAlarme)
            tuiles.push(<Tuile iconName="AlarmClock" key="alarmes" onClick={onDismiss} text="Alarmes" to="/Alarmes" />);

        if (afficherTuileSignatureEiffage)
            tuiles.push(<Tuile iconName="InsertSignatureLine" key="signatures" onClick={onDismiss} text="Signature Eiffage" to="/SignaturesEiffage/ContratsDeReservations" />);

        return <Panel
            isOpen={isOpen}
            type={PanelType.customNear}
            customWidth="730px"
            onDismiss={onDismiss}
            onRenderFooterContent={this._onRenderFooterContent}
        >
            <div className="tiles-grid">
                {[tuiles]}
            </div>
        </Panel>;

    };

};